import { useId } from 'react'
import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

export function BiddingWidgetSkeleton() {
  const theme = useTheme()
  const key = useId()

  return (
    <ContentLoader
      backgroundColor={theme.colours.grey[45]}
      foregroundColor={theme.colours.grey[30]}
      height={88}
      speed={2}
      width={250}
      uniqueKey={key}
      viewBox="0 0 250 88"
    >
      <rect x="0" y="0" rx="3" ry="3" width="250" height="16" />
      <rect x="0" y="24" rx="3" ry="3" width="215" height="16" />
      <rect x="0" y="48" rx="3" ry="3" width="232" height="16" />
      <rect x="0" y="72" rx="3" ry="3" width="118" height="16" />
    </ContentLoader>
  )
}
